/* eslint-disable react/jsx-props-no-spreading */
import { useHistory, useParams } from 'react-router-dom';
import { BsChevronLeft, BsFiles } from 'react-icons/bs';
import { Button, Loader } from 'ypf-pas-general-ui-components';

import PillStatus from '../../../components/PillStatus/PillStatus';
import './MonthlyDetailServiceRequest.scss';
import { useWorkReportModals } from '../../../context/WorkReportModalsContext';
import WorkReportModals from '../../../components/WorkReportModals/WorkReportModals';
import { aprobador, consultaServicios, solicitante } from '../../../security/constantsRols';
import { checkRol } from '../../../security';
import { useDetailServiceRequest } from '../../../context/DetailServiceRequestProvider';

import MonthlyDescriptionServiceRequest from './MonthlyDescription/MonthlyDescriptionServiceRequest';
import MonthlyTabsDetails from './MonthlyTabsDetails/MonthlyTabsDetails';

const MonthlyDetailServiceRequest = () => {
  const { props, showModal, hideModal } = useWorkReportModals();
  const { details, getDetails: getDetailsHeader, loading } = useDetailServiceRequest();
  const history = useHistory();

  const { id } = useParams();

  const accepted = details?.proveedoresAceptados;
  const reject = details?.proveedoresRechazados;
  const totally = details?.proveedoresTotales;
  const responsetotally = accepted + reject === totally;
  const pastTime = details?.pasoFechaRespuesta;
  const styleJustify = pastTime ? 'header-detail-justify' : 'header-detail';
  const idStatus = details?.estadoEnum;
  const codigo = details?.numero;

  return (
    <div className="container container-monthly-detail">
      {loading && <Loader show text="CARGANDO ..." />}
      <div className={`${styleJustify}`}>
        <div className="title">
          <Button
            colorIcon="primary"
            icon={BsChevronLeft}
            onClick={() => {
              sessionStorage.removeItem('equipoSeleccionado');
              history.push(
                checkRol(aprobador) && !checkRol(solicitante) && !checkRol(consultaServicios)
                  ? '/approver'
                  : '/'
              );
            }}
            type="button"
            variant="white"
            widthButton="42px"
          />
          <h2>Solicitud de servicio N° {codigo}</h2>

          <span className="content-button">
            <Button
              colorIcon="primary"
              icon={BsFiles}
              onClick={() => {
                navigator.clipboard.writeText(codigo);
              }}
              sizeIcon="15px"
              type="button"
              variant="white"
              widthButton="30px"
            />
          </span>
        </div>
        <div>
          <PillStatus
            accepted={accepted}
            idStatus={idStatus}
            pastTime={pastTime}
            reject={reject}
            responsetotally={responsetotally}
            totally={totally}
          />
        </div>
      </div>
      <MonthlyDescriptionServiceRequest details={details} />
      {details ? (
        <MonthlyTabsDetails
          details={details}
          getDetailsMonthlyHeader={getDetailsHeader}
          idStatus={idStatus}
          requestData={{ nroSolicitud: id }}
        />
      ) : null}

      <WorkReportModals
        isOyM={details?.esOyM}
        {...props}
        onHide={hideModal}
        showModal={showModal}
      />
    </div>
  );
};

export default MonthlyDetailServiceRequest;
